export const CardImages = [
  {
    id: 1,
    src: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/VISA.svg",
    alt: "visa card image",
  },
  {
    id: 2,
    src: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/mastercard.svg",
    alt: "master card image",
  },
  {
    id: 3,
    src: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/Rupay.svg",
    alt: "Rupay card image",
  },
  {
    id: 3,
    src: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/WeAccept/AMEX.svg",
    alt: "American card image",
  },
];